import { useEffect } from 'react';
import { useNotesModal } from '../contexts/NotesModalContext';

/**
 * Component that manages the notes modal lifecycle
 * Clears modal state on logout
 */
const NotesModalManager = ({ isAuthenticated }) => {
  const { clearNotesModal } = useNotesModal();

  useEffect(() => {
    // Clear notes modal when user logs out
    if (!isAuthenticated) {
      clearNotesModal();
    }
  }, [isAuthenticated, clearNotesModal]);

  return null; // This component doesn't render anything
};

export default NotesModalManager;
